import type { FaireProductEntity } from "../../entity_types/product";

export const p_xv259r4ud8: FaireProductEntity = {
  token: "p_xv259r4ud8",
  type: "product",
  name: "* KIDS * It's Ok Smile Boxy Cotton Kids T-Shirt",
  brandToken: "b_jbqutfkjxx",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/d5b4d038d99be5488d003f5655dc4b0923766d4c6b1dce6bf36e772239df6cd7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/38a008188bb8132f56db5fed2943d7d9770e41a7698e2fa0a7a0b39e9f01d25a.png",
    "https://cdn.faire.com/fastly/d842f98992fe4df074e19c1ca52fb7b9f2fd9194e9ac8f2043e62c31d4c3cc90.png",
    "https://cdn.faire.com/fastly/82068232a81aec05a9ba2d6d63d3cc9d05d24aacdd25b6586206fd989c60e682.png",
    "https://cdn.faire.com/fastly/092c3046a1c79c4c9ee70f88b6405fa8dcf06568530cece679aecb2c18309f75.png"
  ],
  priceDollars: 20.79,
  description: "* MADE IN USA. 6.5 OZ. 100% COTTON. *\n\nGet all of the southwestern vibes in our *NEW* Kids boxy cotton It's Ok Smile graphic tshirt!\n\n- Features \"It's Ok\" with a smile illustration in a black and gold ink\n\n- Screen print transfer that is heat pressed onto each tshirt\n\n- Tshirt is a super soft vintage wash that gets softer after each wash, features drop shoulder and a double stitch collar\n\n- Meant to be a Boxy fit\n\n- Refer to photos for size references on how the tees fit -- Model in Ivory is typically a size 2T wearing a size 4/5 for an oversized look\n\n- 100% Cotton\n\n* due to screens and filters colors may vary slightly to photos - colors on mock up most closely represent the color of the actual item as our product photos have filters that can affect the colors / lighting *",
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:44.811Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
